module.exports = __webpack_public_path__ + "img/hong-leong-bank-img.cd585690.png";